import { Route } from "react-router";
import OrganizationsListPage from "@/features/organizations/pages/list/organizations-list.page";
import { organizationsPathPatterns } from "@/features/organizations/routes/organizations-path-patterns";

export const organizationsRoutes = [
  <Route path={organizationsPathPatterns.list} element={<OrganizationsListPage />} key="organizations-list" />,
];
